import type { Source } from "@/hooks/use-sources";
import { categorizeSource } from "./source-status";

interface SourcesSummaryStripProps {
  sources: Source[];
}

/**
 * One-line stats summary above the Sources section.
 * Leads with the actionable count (need processing) to mirror the page's
 * action-first prioritization — the processed count is derivable.
 */
export function SourcesSummaryStrip({ sources }: SourcesSummaryStripProps) {
  let needProcessing = 0;
  let itemsExtracted = 0;
  for (const s of sources) {
    const cat = categorizeSource(s);
    if (cat === "failed" || cat === "notProcessed") needProcessing++;
    if (s.itemsExtracted != null) itemsExtracted += s.itemsExtracted;
  }
  const total = sources.length;

  return (
    <div className="text-xs text-muted-foreground tabular-nums">
      {total} {total === 1 ? "source" : "sources"} ·{" "}
      <span className="text-foreground/80">
        {needProcessing} {needProcessing === 1 ? "needs" : "need"} processing
      </span>{" "}
      · {itemsExtracted} {itemsExtracted === 1 ? "item" : "items"} extracted
    </div>
  );
}
